(() => {
  if (customElements.get('meg-catalogue-browser')) return;
  const normalise = value => String(value || '').toLowerCase().normalize('NFKD').replace(/organizer/g, 'organiser').replace(/[^a-z0-9]+/g, ' ').trim();
  const priced = item => Number.isSafeInteger(item.amount) && item.amount > 0;
  const loadData = url => {
    window.MEGCatalogueRequests ||= new Map();
    if (!window.MEGCatalogueRequests.has(url)) {
      window.MEGCatalogueRequests.set(url, fetch(url).then(response => {
        if (!response.ok) throw new Error('Catalogue unavailable');
        return response.json().then(async data => data.files ? { ...data, items: (await Promise.all(data.files.map(file => loadData(new URL(file, new URL(url, location.origin)).href)))).flatMap(part => part.items) } : data);
      }).catch(error => { window.MEGCatalogueRequests.delete(url); throw error; }));
    }
    return window.MEGCatalogueRequests.get(url);
  };
  class MEGCatalogueRange extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.labels = JSON.parse(this.querySelector('[data-catalogue-labels]').textContent);
      this.grid = this.querySelector('.meg-catalogue__grid');
      this.filter = this.querySelector('[data-catalogue-filter]');
      this.query = this.querySelector('[data-catalogue-query]');
      this.sort = this.querySelector('[data-catalogue-sort]');
      this.pricedOnly = this.querySelector('[data-catalogue-priced]');
      this.count = this.querySelector('[data-catalogue-count]');
      this.pagination = this.querySelector('[data-catalogue-pagination]');
      this.previous = this.querySelector('[data-catalogue-previous]');
      this.next = this.querySelector('[data-catalogue-next]');
      this.pageLinks = this.querySelector('[data-catalogue-pages]');
      this.floatingNext = this.querySelector('[data-catalogue-floating-next]');
      this.departmentPage = this.dataset.department !== 'all' || this.dataset.source === 'eot';
      this.showing = this.querySelector('[data-catalogue-showing]');
      this.empty = this.querySelector('[data-catalogue-empty]');
      this.retry = this.querySelector('[data-catalogue-retry]');
      const params = new URL(location.href).searchParams;
      const requestedPage = Number(params.get('meg_page'));
      this.page = this.departmentPage && Number.isSafeInteger(requestedPage) && requestedPage > 0 ? requestedPage : 1;
      this.singleItem = this.dataset.singleItem === 'true';
      this.itemAnchor = this.singleItem ? params.get('meg_item') : null;
      this.pageSize = 40; // MEG density: 40 catalogue previews per page, up from 24
      this.query.value = params.get('meg_q') || '';
      if (this.pricedOnly) this.pricedOnly.checked = params.get('meg_priced') === '1';
      this.pricedOnly?.addEventListener('change', () => this.update(), { signal });
      for (const link of this.querySelectorAll('[data-eot-range-link]')) { const url = new URL(link.href); const preview = params.get('preview_theme_id'); if(preview)url.searchParams.set('preview_theme_id',preview);link.href=url.href; }
      if (this.departmentPage && ['featured','price-low','price-high','name'].includes(params.get('meg_sort'))) this.sort.value = params.get('meg_sort');
      this.filter?.addEventListener('change', () => this.update(), { signal });
      this.sort.addEventListener('change', () => this.update(), { signal });
      this.query.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 150); }, { signal });
      if (!this.departmentPage) {
        this.previous.addEventListener('click', () => { this.page--; this.render(true); }, { signal });
        this.next.addEventListener('click', () => { this.page++; this.render(true); }, { signal });
      }
      this.retry.addEventListener('click', () => { this.loading = null; this.load(); }, { signal });
      window.addEventListener('hashchange', () => this.revealHash(), { signal });
      window.addEventListener('popstate', () => this.revealHash(), { signal });
      this.addEventListener('meg:reveal-preview', event => this.revealItem(event.target.closest('article')?.id), { signal });
      if (!this.singleItem && (location.hash.startsWith('#meg-preview-') || this.query.value)) this.revealHash();
      if (this.singleItem || this.departmentPage) this.load();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { this.observer.disconnect(); this.load(); } }, { rootMargin: '450px' });
        this.observer.observe(this);
        if (this.floatingNext) {
          window.addEventListener('scroll', () => this.queueFloating(), { capture:true, passive:true, signal });
          window.addEventListener('resize', () => this.queueFloating(), { signal });
        }
      } else this.load();
      if (this.departmentPage && params.has('meg_page')) this.load();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect(); cancelAnimationFrame(this.positionFrame); this.positionFrame = 0; clearTimeout(this.timer);
    }
    async load() {
      if (this.loading) return this.loading;
      this.count.textContent = this.labels.loading;
      const urls = this.dataset.source === 'eot' ? [this.dataset.extraCatalogueUrl] : [this.dataset.catalogueUrl, this.dataset.extraCatalogueUrl].filter(Boolean);
      const launchFiles = ['meg-launch-products-20261027-ek.json', 'meg-launch-products-20261027-tbtrade.json'];
      this.loading = Promise.all([...urls.map(loadData), ...launchFiles.map(file => fetch(new URL(file, new URL(this.dataset.catalogueUrl, location.origin)).href).then(response => { if (!response.ok) throw new Error('Launch catalogue unavailable'); return response.json(); }))]).then(results => {
        const launchParts = results.splice(-launchFiles.length);
        const launch = Object.assign({}, ...launchParts.map(part => part.items || {}));
        const data = results;
        const seen = new Set();
        this.items = data.flatMap(part => part.items).filter(item => { const id = String(item.nativeVariantId || ''); if (['55351132520789','55353669714261'].includes(id) || !launch[id] || seen.has(id)) return false; seen.add(id); return true; }).map(item => ({ ...item, ...launch[String(item.nativeVariantId)], nativeUrl: launch[String(item.nativeVariantId)].url })).filter(item => (this.dataset.source !== 'eot' || item.source === 'eot') && (this.dataset.department === 'all' || item.department === this.dataset.department) && (this.dataset.subcategory === 'all' || item.subcategory === this.dataset.subcategory));
        this.retry.hidden = true;
        this.render();
        if (this.departmentPage && new URL(location.href).searchParams.has('meg_page')) {
          this.closest('section').scrollIntoView({block:'start',behavior:'instant'});
          this.grid.focus({preventScroll:true});
        }
        return true;
      }).catch(() => { this.count.textContent = this.labels.loadError; this.retry.hidden = false; this.loading = null; return false; });
      return this.loading;
    }
    async update() {
      if (!(await this.load())) return;
      this.page = 1;
      if (this.departmentPage) {
        const url = this.pageURL(1);
        url.hash = location.hash;
        history.replaceState(history.state, '', url);
      }
      this.render();
    }
    pageURL(page) {
      const url = new URL(location.href);
      url.searchParams.set('meg_page', String(page));
      if(this.pricedOnly?.checked)url.searchParams.set('meg_priced','1');else url.searchParams.delete('meg_priced');
      if (this.query.value.trim()) url.searchParams.set('meg_q', this.query.value.trim());
      else url.searchParams.delete('meg_q');
      if (this.sort.value !== 'featured') url.searchParams.set('meg_sort', this.sort.value);
      else url.searchParams.delete('meg_sort');
      url.hash = this.closest('section').id;
      return url;
    }
    setPageLink(link, page, enabled) {
      if (!link) return;
      link.setAttribute('aria-disabled', String(!enabled));
      if (enabled) { link.href = this.pageURL(page); link.removeAttribute('tabindex'); }
      else { link.removeAttribute('href'); link.setAttribute('tabindex', '-1'); }
    }
    syncFloating() {
      if (!this.floatingNext) return;
      this.floatingNext.hidden = !this.hasNext;
      if (!this.hasNext) return;
      const arrow = this.floatingNext.getBoundingClientRect();
      const grid = this.grid.getBoundingClientRect();
      const middle = arrow.top + arrow.height / 2;
      this.floatingNext.hidden = grid.top > middle || grid.bottom < middle;
    }
    queueFloating() {
      if (this.positionFrame) return;
      this.positionFrame = requestAnimationFrame(() => {
        this.positionFrame = 0;
        this.syncFloating();
      });
    }
    filtered() {
      const terms = normalise(this.query.value).split(' ').filter(Boolean);
      const rows = this.items.filter(item => (!this.pricedOnly?.checked || priced(item)) && (!this.filter || this.filter.value === 'all' || item.department === this.filter.value) && terms.every(term => normalise(item.title + ' ' + item.sku + ' ' + this.labels.departments[item.department] + ' ' + this.labels.categories[item.subcategory]).includes(term)));
      if (this.sort.value === 'price-low') rows.sort((a,b) => priced(a)!==priced(b) ? Number(priced(b))-Number(priced(a)) : (a.amount||0)-(b.amount||0));
      if (this.sort.value === 'price-high') rows.sort((a,b) => priced(a)!==priced(b) ? Number(priced(b))-Number(priced(a)) : (b.amount||0)-(a.amount||0));
      if (this.sort.value === 'name') rows.sort((a,b) => a.title.localeCompare(b.title, 'en-GB'));
      return rows;
    }
    card(item) {
      const article = document.createElement('article'); article.className = 'meg-catalogue__card'; article.id = item.anchor; article.dataset.catalogueDepartment = item.department; article.dataset.studioVariant = String(item.nativeVariantId || ''); article.dataset.studioUrl = this.itemURL(item);
      const image = document.createElement('img'); if(item.image)image.src = item.image; image.alt = item.title; image.width = 720; image.height = 720; image.loading = 'lazy'; image.decoding = 'async';
      if (item.image && window.matchMedia('(max-width:749px)').matches) {
        const source = new URL(item.image, location.origin);
        if (source.hostname === 'cdn.shopify.com' || (source.origin === location.origin && source.pathname.startsWith('/cdn/shop/'))) {
          image.sizes = 'auto, 100vw';
          image.srcset = [320, 640, 960, 1200].map(width => { const url = new URL(source.href); url.searchParams.set('width', width); return url.href + ' ' + width + 'w'; }).join(', ');
        }
      }
      const body = document.createElement('div'); body.className = 'meg-catalogue__body';
      const department = document.createElement('p'); department.className = 'meg-catalogue__department'; department.textContent = this.labels.departments[item.department];
      const title = document.createElement('h3'); const titleLink = document.createElement('a'); titleLink.href = this.itemURL(item); titleLink.textContent = item.title; title.append(titleLink); title.title = item.title;
      const price = document.createElement('p'); price.className = 'meg-catalogue__price'; price.textContent = priced(item) ? this.labels.plannedPrice.replace('__PRICE__', new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(item.amount/100)) : this.labels.pricePending;
      const badge = document.createElement('span'); badge.className = 'meg-catalogue__badge'; badge.textContent = this.labels.badge;
      const details = document.createElement('details'); const summary = document.createElement('summary'); summary.textContent = this.labels.details;
      const description = document.createElement('div'); description.className = 'meg-catalogue__details';
      if (item.details) description.innerHTML = item.details;
      const reference = document.createElement('p'); reference.textContent = this.labels.reference.replace('__SKU__',item.sku); description.append(reference);
      if (!item.details || item.needsReview) { const note=document.createElement('p'); note.textContent=this.labels.reviewNote; description.append(note); }
      details.append(summary,description); body.append(department,title,price,badge);
      if (item.nativeUrl || !this.singleItem || item.anchor !== this.itemAnchor) {
        const link = document.createElement('a'); link.className = 'meg-catalogue__product-link';
        link.href = this.itemURL(item); link.textContent = this.labels.exploreProduct; body.append(link);
      }
      const planLabels=JSON.parse(document.querySelector('[data-plan-labels]')?.textContent||'{}');
      const amount=Number(item.amount)/100;
      if(priced(item)&&Number.isFinite(amount)&&amount>0&&item.sku&&planLabels.add){
        const add=document.createElement('button');add.type='button';add.className='meg-catalogue__plan-button';add.textContent=planLabels.add||'';
        const d=item.department==='technology'?'tech':item.department;
        const itemURL=this.itemURL(item);
        add.dataset.megPlanItem=JSON.stringify({key:'ref:'+(item.source||'godropship')+':'+encodeURIComponent(item.sku),supplierId:item.source||'godropship',sku:item.sku,title:item.title,price:Math.round(amount*100),quantity:1,department:d,image:item.image,url:itemURL});body.append(add);
      }
      body.append(details);
      if(item.image){const link=document.createElement('a');link.className='meg-catalogue__photo-button';link.href=this.itemURL(item);link.setAttribute('aria-label',item.title);link.append(image);article.append(link);}else{const pending=document.createElement('div');pending.className='meg-catalogue__photo-pending';pending.textContent=this.labels.photoPending;article.append(pending);}
      article.append(body); return article;
    }
    itemURL(item) {
      const url = new URL(item.nativeUrl || this.labels.itemBaseUrl, location.origin);
      if (!item.nativeUrl) {
        url.searchParams.set('view', 'meg-item');
        url.searchParams.set('meg_item', item.anchor);
      }
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    }
    relatedItems(item) {
      const stop = new Set(['with','for','and','the','pack','set','black','white','inch','pcs','piece','of']);
      const terms = new Set(normalise(item.title).split(' ').filter(word => word.length > 2 && !stop.has(word) && !/^\d+$/.test(word)));
      const affinities = [
        /\b(toolbox|tools?|screwdriver|drill|hammer|wrench|pliers|repair|measuring|tape|diy)\b/,
        /\b(wardrobe|hangers?|clothes|laundry|shoe|shoes)\b/,
        /\b(cables?|cord|charger|charging|usb|phone)\b/,
        /\b(dog|puppy|pet|cat|kitten)\b/,
        /\b(kitchen|cooking|cookware|utensil|pan|baking)\b/,
        /\b(car|vehicle|seat|automotive)\b/,
        /\b(christmas|festive|xmas|bauble)\b/
      ].filter(group => group.test(normalise(item.title)));
      const seen = new Set([item.anchor]);
      return this.items.filter(row => {
        if (!row.anchor || seen.has(row.anchor) || (row.sku && row.sku === item.sku)) return false;
        seen.add(row.anchor); return true;
      }).map(row => {
        const overlap = new Set(normalise(row.title).split(' ').filter(word => terms.has(word))).size;
        const sameCategory = item.subcategory && item.subcategory !== 'all' && row.subcategory === item.subcategory;
        const sameDepartment = row.department === item.department;
        return { item: row, score: (affinities.some(group => group.test(normalise(row.title))) ? 50 : 0) + (sameCategory ? 30 : 0) + (sameDepartment ? 30 : 0) + overlap * 12 + (row.image ? 1 : 0) };
      }).sort((a,b) => b.score - a.score || a.item.title.localeCompare(b.item.title)).slice(0,4).map(row => row.item);
    }
    renderRelated(item) {
      this.querySelector('.meg-item-related')?.remove();
      const items = this.relatedItems(item);
      if (!items.length) return;
      const section = document.createElement('section'); section.className = 'meg-item-related';
      const heading = document.createElement('h2'); heading.textContent = this.labels.moreChoices;
      const intro = document.createElement('p'); intro.textContent = this.labels.moreChoicesIntro;
      const grid = document.createElement('div'); grid.className = 'meg-item-related__grid';
      grid.append(...items.map(row => this.card(row))); section.append(heading,intro,grid);
      this.grid.after(section);
    }
    render(scroll=false) {
      if (!this.items) return;
      if (this.singleItem) {
        const item = this.items.find(row => row.anchor === this.itemAnchor);
        this.pagination.hidden = true;
        if (!item) { this.grid.replaceChildren(); this.empty.textContent = this.labels.empty; this.empty.hidden = false; return; }
        const card = this.card(item);
        card.querySelector('details').open = true;
        const oldTitle = card.querySelector('h3');
        const heading = document.createElement('h1'); heading.textContent = item.title; heading.id = this.closest('section').getAttribute('aria-labelledby'); oldTitle.replaceWith(heading);
        this.querySelector('.meg-catalogue__head h2')?.removeAttribute('id');
        card.querySelector('img')?.setAttribute('loading', 'eager');
        this.grid.replaceChildren(card); this.empty.hidden = true;
        document.title = item.title + ' — MaximusElonGlobal';
        this.renderRelated(item);
        return;
      }
      const rows = this.filtered(); const pages = Math.max(1,Math.ceil(rows.length/this.pageSize)); this.page=Math.max(1,Math.min(this.page,pages));
      const first=(this.page-1)*this.pageSize; this.grid.replaceChildren(...rows.slice(first,first+this.pageSize).map(item=>this.card(item)));
      this.dispatchEvent(new CustomEvent('meg:studio-render',{bubbles:true}));
      this.count.textContent=(rows.length===1?this.labels.countOne:this.labels.countOther).replace('__COUNT__',rows.length.toLocaleString('en-GB'));
      if (this.departmentPage) this.count.textContent += ' · ' + this.labels.pageNumber.replace('__PAGE__',String(this.page)).replace('__PAGES__',String(pages));
      this.empty.textContent=this.labels.empty; this.empty.hidden=!!rows.length; this.pagination.hidden=!rows.length;
      this.hasNext = this.page < pages && !!rows.length;
      if (this.departmentPage) {
        this.setPageLink(this.previous, this.page - 1, this.page > 1);
        this.setPageLink(this.next, this.page + 1, this.hasNext);
        this.setPageLink(this.floatingNext, this.page + 1, this.hasNext);
        const numbers = [...new Set([1, this.page - 1, this.page, this.page + 1, pages])].filter(number => number > 0 && number <= pages).sort((a,b)=>a-b);
        const links = [];
        for (let index = 0; index < numbers.length; index++) {
          const number = numbers[index];
          if (index && number - numbers[index - 1] > 1) { const gap = document.createElement('span'); gap.textContent = '…'; gap.setAttribute('aria-hidden','true'); links.push(gap); }
          const link = document.createElement('a'); link.href = this.pageURL(number); link.textContent = String(number);
          link.setAttribute('aria-label',this.labels.pageNumber.replace('__PAGE__',String(number)).replace('__PAGES__',String(pages)));
          if (number === this.page) link.setAttribute('aria-current','page');
          links.push(link);
        }
        this.pageLinks.replaceChildren(...links);
        this.syncFloating();
      } else { this.previous.disabled=this.page===1; this.next.disabled=this.page>=pages; }
      const showing=this.labels.showing.replace('__START__',String(rows.length?first+1:0)).replace('__END__',String(Math.min(first+this.pageSize,rows.length))).replace('__TOTAL__',rows.length.toLocaleString('en-GB'));
      this.showing.textContent=this.departmentPage ? this.labels.pageNumber.replace('__PAGE__',String(this.page)).replace('__PAGES__',String(pages)) + ' · ' + showing : showing;
      if(scroll) this.closest('section').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    async setQuery(value) {
      this.query.value=value; if(this.filter)this.filter.value='all'; this.sort.value='featured'; this.page=1; await this.update();
    }
    async revealItem(anchor) {
      if(!anchor || !(await this.load())) return false;
      const index=this.items.findIndex(item=>item.anchor===anchor); if(index<0)return false;
      this.query.value=''; if(this.filter)this.filter.value='all'; if(this.pricedOnly)this.pricedOnly.checked=false; this.sort.value='featured'; this.page=Math.floor(index/this.pageSize)+1; this.render();
      const card=this.querySelector('#'+CSS.escape(anchor)); if(!card)return false;
      card.querySelector('details').open=true; card.scrollIntoView({block:'start'}); card.querySelector('summary').focus({preventScroll:true}); return true;
    }
    async revealHash() { if(location.hash.startsWith('#meg-preview-'))await this.revealItem(location.hash.slice(1)); else await this.load(); }
  }
  customElements.define('meg-catalogue-browser',MEGCatalogueRange);
})();




